// Charte des propositions Innowide, alignée sur les decks HTML d'Innowide (atelier Genesis Lab) : fond blanc,
// étiquette en capitales bleues, titre Montserrat noir, logo en haut à droite, pied de page gris ; couverture claire.
// Canevas 1280 × 720 ; contenu de y = 165 à 660.
export const W = 1280;
export const H = 720;
export const CONTENT = { left: 64, top: 165, width: 1152, bottom: 660 };
// Le contenu peut descendre sous la zone utile jusqu'au bas du canevas (y = 700), sur toutes les slides ; le pied de
// page (référence et numéro) se loge dessous, dans la dernière bande.
export const FOOTER_TOP = 702;
export const contentLimit = () => H - 20;

export const C = {
  black: "#000000",
  body: "#4B5563",
  muted: "#6B7280",
  blue: "#3C83F6",
  pale: "#EBF2FF",
  line: "#C9DBFB",
  white: "#FFFFFF",
};

export const FONT = "Arial, Helvetica, sans-serif";
export const DISPLAY = "'Montserrat', Arial, sans-serif";
export const LOGO = "/offers/innowide-logo-bleu.png";

// Logo recadré sur son contenu (avec 8 px de marge à 800 px de large) : largeur = hauteur × LOGO_RATIO.
export const LOGO_RATIO = 4.124;

export const INNOWIDE = {
  name: "Innowide",
  address: "25 rue Arthur Rimbaud\n91400 Saclay, France",
  contact: "contact@innowide.fr",
  site: "innowide.fr",
  legal: "INNOWIDE  |  SAS au capital social de 4 000,00 €  |  SIREN 831 937 081  |  TVA FR91831937081",
};

// Avance des caractères de Montserrat Bold, en em (mesurée dans le navigateur) : la taille des titres se calcule
// sans attendre le chargement de la police, à l'identique dans l'éditeur, le PDF et le rendu des agents.
const ADVANCE = {
  " ": 0.28, a: 0.62, b: 0.69, c: 0.59, d: 0.69, e: 0.63, f: 0.39, g: 0.7, h: 0.69, i: 0.3, j: 0.31, k: 0.66,
  l: 0.3, m: 1.05, n: 0.69, o: 0.66, p: 0.69, q: 0.69, r: 0.43, s: 0.53, t: 0.44, u: 0.69, v: 0.6, w: 0.94, x: 0.6,
  y: 0.6, z: 0.54, A: 0.77, B: 0.77, C: 0.72, D: 0.83, E: 0.67, F: 0.64, G: 0.77, H: 0.81, I: 0.33, J: 0.54,
  K: 0.74, L: 0.6, M: 0.96, N: 0.81, O: 0.84, P: 0.73, Q: 0.84, R: 0.74, S: 0.64, T: 0.62, U: 0.79, V: 0.75,
  W: 1.16, X: 0.71, Y: 0.68, Z: 0.67, 0: 0.68, 1: 0.39, 2: 0.59, 3: 0.59, 4: 0.69, 5: 0.6, 6: 0.64, 7: 0.62,
  8: 0.66, 9: 0.64, "œ": 1.06, "æ": 1, "Œ": 1.14, ".": 0.26, ",": 0.26, ";": 0.26, ":": 0.26, "!": 0.29, "?": 0.59,
  "'": 0.23, "’": 0.26, '"': 0.44, "«": 0.57, "»": 0.57, "(": 0.36, ")": 0.36, "-": 0.39, "–": 0.5, "—": 1,
  "/": 0.39, "&": 0.73, "%": 0.88, "€": 0.81, $: 0.64, "+": 0.6, "=": 0.6, "×": 0.6, "→": 1, "·": 0.3, "…": 0.8,
  "_": 0.5, "#": 0.72, "@": 1.04, "*": 0.43, " ": 0.28, " ": 0.2,
};
const advance = (char) => ADVANCE[char] ?? ADVANCE[char.normalize("NFD")[0]] ?? 0.65;
export const displayWidth = (text, size) => [...(text || "")].reduce((sum, char) => sum + advance(char), 0) * size;

// Plus grande taille (de max à min) qui tient sur une ligne de la largeur donnée ; sinon la plus petite.
const fitSize = (text, width, max, min) => {
  let size = max;
  while (size > min && displayWidth(text, size) > width) size -= 1;
  return size;
};

// Titre d'une slide : une ligne de 40 à 24 px ; au-delà, deux lignes serrées en 22 px, entre l'étiquette et le
// sous-titre, sous le logo (signalé aux agents).
export const TITLE = { max: 40, min: 24, twoLines: 22, width: CONTENT.width };
export const titleFit = (title) => {
  const size = fitSize(title, TITLE.width, TITLE.max, TITLE.min);
  return displayWidth(title, size) <= TITLE.width ? { size, oneLine: true } : { size: TITLE.twoLines, oneLine: false };
};

// Titre de couverture : deux lignes au plus, de 64 à 40 px.
export const COVER_TITLE = { max: 64, min: 40, width: 1100 };
export const coverTitleSize = (title) => fitSize(title, COVER_TITLE.width * 2 * 0.92, COVER_TITLE.max, COVER_TITLE.min);

export const longDate = (iso) => {
  if (!iso) return "";
  const date = new Date(`${iso}T12:00:00`);
  return Number.isNaN(date.getTime())
    ? ""
    : date.toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
};

export const euro = (value) => `${Math.round(Number(value) || 0).toLocaleString("fr-FR")} €`;

// Prix unitaire d'un lot chiffré en quantité : au centime, sauf s'il tombe juste.
export const unitEuro = (value) => {
  const number = Number(value) || 0;
  return Number.isInteger(number) ? euro(number)
    : `${number.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
};

// « 4 boîtiers à 1 225,53 € HT » : vide si le lot n'est pas chiffré en quantité.
export const unitLine = (lot, discount) => {
  const quantity = Number(lot?.quantity) || 1;
  if (quantity === 1) return "";
  const unit = lot.unit || "unité";
  const plural = quantity > 1 && !/[sxz]$/i.test(unit) ? `${unit}s` : unit;
  return `${quantity.toLocaleString("fr-FR")} ${plural} à ${unitEuro(lot.unit_net)} HT${discount ? " remisé" : ""} l'unité`;
};

export const weeks = (value) => {
  const number = Number(value);
  if (!number) return "";
  const text = String(Math.round(number * 10) / 10).replace(".", ",");
  return `${text} semaine${number > 1 ? "s" : ""}`;
};
